const mapContentFolding = (block, classWrapper = "bn-map__locations--mobile", contenerToFold = "bn-map__locations-list", openClass = "bn-map__open-button ") => {
    const classShrinkedObjecWrapper = classWrapper;
    const classToShrinkedObject = contenerToFold;
    const classToOpenTheShrink = openClass;

    const shrinkedObjectWrappers = block ? block[0].querySelectorAll('.' . classShrinkedObjecWrapper) : document.querySelectorAll('.' . classShrinkedObjecWrapper);

    shrinkedObjectWrappers.forEach((shrinkedObjectWrapper) => {
        const tmpInner = shrinkedObjectWrapper.querySelector('.' + classToShrinkedObject);
        const tmpOpen = shrinkedObjectWrapper.querySelector('.' + classToOpenTheShrink);

        if (tmpInner && tmpOpen) {
            tmpOpen.addEventListener('click', (e) => {
                if (!tmpInner.classList.contains('opened')) {
                    tmpInner.style.height = 'auto';
                    tmpInner.classList.toggle('opened');
                    tmpOpen.remove();
                }
            })
        }
    });

}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains( 'block-editor-page' ) && !document.body.classList.contains( 'block-editor-iframe__body' ))
        mapContentFolding(
            null,
            "bn-map__locations--mobile",
            "bn-map__locations-list",
            "bn-map__open-button "
        );
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/map', mapContentFolding);
});